// extracted by mini-css-extract-plugin
export default {"wrapper":"dcc_disclaimerText-wrapper"};